const customerDomainReplaces = {
	list: {
		'grant_thornton': 'grantthornton',
	}
}

export default customerDomainReplaces
